<template>
  <div>
    <title-edit header="Membership rate" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Branch :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.detail_th" @update="updateDetailTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.detail_en" @update="updateDetailEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>One day pass TH :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.one_day_pass_th" @update="updateOneDayPassTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>One day pass EN :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.one_day_pass_en" @update="updateOneDayPassEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Annual fee TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.annual_fee_th" @update="updateAnnualFeeTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Annual fee EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.annual_fee_en" @update="updateAnnualFeeEN" />
      </v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteMembershipRate" @save-info="saveMembershipRate" @save-close="saveClose"></command-button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import SelectOption from "../../../components/Input/selectOption";
import InputEditor from "../../../components/Input/InputEditor";
import InputTextField from "../../../components/Input/InputTextField";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import SwitchSelect from "../../../components/Input/StyleUtility";
import {permissionMembershipRate, role} from "../../../util/Permission";
import Swal from 'sweetalert';
import CommandButton from "../../../components/Layout/CommandButton";

export default {
  name: "MembershipRateEdit",
  components: {
    CommandButton,
    SwitchSelect,
    SaveButton,
    PreviewButton,
    DeleteButton,
    InputTextField,
    InputEditor,
    SelectOption,
    LineHr,
    TitleEdit
  },
  computed: {
    permissionMembershipRate,
    ...mapState({
      form: state => state.MembershipRate.form
    })
  },
  data() {
    return {
      permission : null,
      optionBranch: [],
      save_id: null
    };
  },
  created() {
    this.permission = role;
    this.getBranchData();
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.filter(val => val.branch_id !== 0).map(type => ({
            value: type.branch_id,
            text: `${type.branch_name_th} (${type.branch_name_en})`
          }))
        ];
      });
    },
    validateSave() {
      // if (!this.form.branch_id) {
      // Swal('','Please select Branch !','error');
      //   return false;
      // }
      if (!this.form.detail_th) {
        Swal('','Please insert Description TH !','error');
        return false;
      }
      if (!this.form.detail_en) {
        Swal('','Please insert Description EN !','error');
        return false;
      }
      if (!this.form.annual_fee_th) {
        Swal('','Please insert Annual Fee TH !','error');
        return false;
      }
      if (!this.form.annual_fee_en) {
        Swal('','Please insert Annual Fee EN !','error');
        return false;
      }

      return true;
    },
    saveClose() {
      this.$store
              .dispatch("MembershipRate/saveMembershipRate", {
                id: this.save_id ? this.save_id : this.form.id,
                data: this.form
              })
              .then(res => {
                Swal(res.response_msg);
                if (res.response_code == 200) {
                  this.goToMembershipRateTable();
                }
              });
    },
    saveMembershipRate() {
      this.$store
        .dispatch("MembershipRate/saveMembershipRate", {
          id: this.save_id ? this.save_id : this.form.id,
          data: this.form
        })
        .then(res => {
          this.save_id = res.result.id;
          Swal(res.response_msg);
        });
    },
    goToMembershipRateTable() {
      this.$router.push("/membership/membership-rate");
    },
    deleteMembershipRate() {
      this.$store
        .dispatch("MembershipRate/deleteMembershipRate", this.form.id)
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToMembershipRateTable();
          }
        })
        .catch(() => {
          Swal('','Delete data failed!','error');
        });
    },
    updateBranch(val) {
      this.form.branch_id = val;
    },
    updateDetailEN(val) {
      this.form.detail_en = val;
    },
    updateDetailTH(val) {
      this.form.detail_th = val;
    },
    updateOneDayPassTH(val) {
      this.form.one_day_pass_th = val;
    },
    updateOneDayPassEN(val) {
      this.form.one_day_pass_en = val;
    },
    updateAnnualFeeTH(val) {
      this.form.annual_fee_th = val;
    },
    updateAnnualFeeEN(val) {
      this.form.annual_fee_en = val;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/switch.css";
</style>
